import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import LogoComponent from "../components/logo-comp";
import StepperComponent from '../components/checkout/stepper-comp';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import EmptyCart from '../components/cart/empty-cart';

const CheckoutPage = () => {
    const { t, i18n } = useTranslation();  
    const orderData = i18n.exists("forms.orderData") ? t('forms.orderData') : "Данни за поръчката";
    const storageCart = localStorage.getItem('cartObject');
    const [cartObject, setCartObject] = useState(Object);
    const [stateCart, setStateCart] = useState(Object);
    const publicUrl = process.env.PUBLIC_URL;
    const defaultImg = publicUrl + "/img/no-photo.png";
    const getCart = () => {
        if(storageCart) {
            setCartObject(JSON.parse(storageCart));
        }
    }

    useEffect(() => {
        getCart();
    }, [stateCart])

    return (
        <div className="pg-form checkout-page">
            {/* <div className="checkout-bg"></div> */}
            <div className="checkout-main">
                <LogoComponent logoColor="white" />
                <div className='checkout-form'>
                    {cartObject && cartObject.items && cartObject.items.length > 0 ? (
                        <Row className="mb-3 checkout-in">
                            <Col md="6" className="margin-0">
                                <StepperComponent />
                            </Col>
                            <Col md="6" className="margin-0">
                                <div className='bg-card'>
                                    <h3>{orderData}</h3>
                                    {cartObject && cartObject.items && cartObject.items.length > 0 ? (
                                        <div className='checkout-items'>
                                            <ul>
                                            {cartObject.items.map((item: any, index: any) => {
                                                    return (
                                                        <li key={index}>
                                                            <div>
                                                                <img src={item.imgSrc ? item.imgSrc : defaultImg} alt="product" className="rounded img-responsive product-thumb" />
                                                                
                                                            </div>
                                                            <div className='inter-light'>{item.title}</div>
                                                        </li>
                                                    )
                                                })}
                                            </ul>
                                        </div>
                                    ) : null}
                                </div>
                            </Col>
                        </Row>
                    ) : (
                        <EmptyCart />
                    )}
                </div>
            </div>
        </div>
    )
}

export default CheckoutPage;